export default __webpack_public_path__ + "static/media/AOfferBanner.6f0021b9.png";